import { IOption, TEmployment, TExperience } from "./types"

export const HH = 'hh'
export const SUPER_JOB = 'SuperJob'
export const RABOTA = "Rabota.ru"
export const TRUD_VSEM = "TrudVsem"

export const RATES_URL = '/rates'
export const VACANCIES_URL = '/vacancies'
export const FILTERS_URL = '/filters'
export const LOGOUT_URL = '/logout'
export const AUTH_URL = '/auth'
export const CONFIRM_PAGE_URL = '/confirm'

export const SOURCES = [
  {
    id: 'hh',
    name: 'HH',
    url: 'https://hh.ru/'
  },
  {
    localId: 'Rabotaru',
    id: 'Rabota.ru',
    name: 'Работа.ру',
    url: 'https://www.rabota.ru/'
  },
  {
    id: 'avito',
    name: 'Avito',
    url: 'https://www.avito.ru/moskva/vakansii'
  },
  {
    id: 'TrudVsem',
    name: 'Trudvsem.ru',
    url: 'https://trudvsem.ru/'
  },
  {
    id: 'SuperJob',
    name: 'SuperJob',
    url: 'https://www.superjob.ru/vakansii/'
  },
  {
    id: 'carier',
    name: 'Карьерист.ру',
    url: 'https://careerist.ru/vakansii/'
  },
  {
    id: 'yandex',
    name: 'Яндекс',
    url: 'https://yandex.ru/jobs'
  },
  {
    id: 'talent',
    name: 'Talent.ru',
    url: 'https://talent.mos.ru/'
  },
  {
    id: 'sallary',
    name: 'Зарплата.ру',
    url: 'https://www.zarplata.ru/'
  },
]

export const DEVELOPMENT = 'dev'

export const NO_EXPERIENCE = "Нет опыта" 
export const LOW_EXPERINECE = "От 1 года до 3 лет" 
export const MID_EXPERIENCE = "От 3 до 6 лет" 
export const HIGH_EXPERIENCE = "Более 6 лет" 
export const ANY_EXPERIENCE = "Не имеет значения"

export const NO = "no" 
export const LOW = "low" 
export const MID = "mid" 
export const HIGH = "high" 
export const ANY = "any"

export const EXPERIENCES: IOption<TExperience>[] = [
  {
    label: ANY_EXPERIENCE,
    value: ANY
  },
  {
    label: NO_EXPERIENCE, 
    value: NO
  },
  {
    label: LOW_EXPERINECE, 
    value: LOW
  },
  {
    label: MID_EXPERIENCE, 
    value: MID
  },
  {
    label: HIGH_EXPERIENCE,
    value: HIGH
  },
]

export const FULL = "full"
export const PART = "part"
export const PROJECT = "project"
export const VOLUNTEER = "volunteer"
export const PROBATION = "probation"
export const SHIFT = "shift"
export const FREE = "free"
export const TEMPORARY = "temporary"
export const REMOTE = "remote"

export const FULL_EMPLOYMENT = "Полная занятость"
export const PART_EMPLOYMENT = "Частичная занятость"
export const PROJECT_EMPLOYMENT = "Проектная работа"
export const VOLUNTEER_EMPLOYMENT = "Волонтерство"
export const PROBATION_EMPLOYMENT = "Стажировка"
export const SHIFT_EMPLOYMENT = "Сменный график"
export const ANY_EMPLOYMENT = "Любая занятость"
export const FREE_EMPLOYMENT = "Свободный график"
export const TEMPORARY_EMPLOYMENT = "Временная работа"
export const REMOTE_EMPLOYMENT = "Удаленная работа"

export const EMPLOYMENTS: IOption<TEmployment>[] = [
  {
    label: FULL_EMPLOYMENT,
    value: FULL
  },
  {
    label: PART_EMPLOYMENT,
    value: PART
  },
  {
    label: PROJECT_EMPLOYMENT,
    value: PROJECT
  },
  {
    label: VOLUNTEER_EMPLOYMENT,
    value: VOLUNTEER
  }, 
  {
    label: PROBATION_EMPLOYMENT,
    value: PROBATION
  },
  {
    label: SHIFT_EMPLOYMENT,
    value: SHIFT
  },
  {
    label: FREE_EMPLOYMENT,
    value: FREE
  },
  {
    label: TEMPORARY_EMPLOYMENT,
    value: TEMPORARY
  },
  {
    label: REMOTE_EMPLOYMENT,
    value: REMOTE
  }
]

